import { AppBar, Link, Toolbar } from "@mui/material";
import React from "react";
import { Link as RouterLink } from "react-router-dom";

import { ariaLabel, PATH_ROOT } from "src/constants";

import { HeaderLogo } from "../HeaderLogo";

const ContentHeader = () => {
  return (
    <AppBar position="static" aria-label={ariaLabel.header} role="banner">
      <Toolbar>
        <Link
          component={RouterLink}
          to={PATH_ROOT}
          style={{ textDecoration: "none", color: "inherit" }}
          aria-label={ariaLabel.customerAreaLinkLabel}
        >
          <HeaderLogo />
        </Link>
      </Toolbar>
    </AppBar>
  );
};

export default ContentHeader;
